import Drawer from '@base/Drawer/DrawerWithFooter';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { useEffect, useState } from 'react';
import Button from '@base/Button/Button';
import pushRoute from '@utils/pushRoute';
import { segment } from '@actions/analytics';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { DOW2_TRY_AN_EXAMPLE } from '@constants/segment';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import useDoubtConfig from '@api/hooks/goal/custom-doubts/useDoubtConfig';
import { submitDoubt } from '@api/fetchers/doubts-and-solutions';
import ConfirmSampleDoubtDetails from './ConfirmSampleDoubtDetails';
import SelectDoubt from './SelectDoubt';

const FooterWrapper = styled.div`
  grid-column: span 10;
  height: ${Spacings.SPACING_18B};
  background: var(--color-base-1);
  display: flex;
  justify-content: space-between;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_10B};
  align-items: center;
  box-shadow: ${boxShadowGenerator({ yOffset: '-16px', blur: '32px' })};
`;

const ContentWrapper = styled.div`
  grid-column: span 10;
`;

const StyButton = styled(Button)`
  margin-right: ${Spacings.SPACING_19B};
  position: relative;
  width: 136px;
  height: ${Spacings.SPACING_10B};
  left: 328px;
  color: var(--color-base-1);
  ${mediaQuery.uptoMobile} {
    left: ${Spacings.SPACING_7B};
  }
`;

const SampleDoubt = ({
  isDrawerOpen,
  setIsDrawerOpened,
  goalUID,
  isASDEnabled,
  setSampleClicked
}) => {
  const { goalInfo } = useGoalInfo(goalUID);

  const drawerScreens = {
    selectDoubt: 'SelectDoubt',
    confirmDetails: 'ConfirmDetails'
  };
  const [drawerScreen, setDrawerScreen] = useState(drawerScreens.selectDoubt);

  const {
    doubtConfigData: { samples = [] }
  } = useDoubtConfig(goalUID);
  const routeGoalSegmentData = useGoalEventProps({ goalUID });
  const [selectedSampleSolution, setSelectedSampleSolution] = useState(
    samples?.[0]
  );
  const { doubt_uid, image } = selectedSampleSolution || {};
  const footerState = {
    doubtSelection: 'Doubt Selection',
    confirmDetails: 'Confirm Deatils'
  };
  const [currentFooterState, setCurrentFooterState] = useState(
    footerState.doubtSelection
  );

  const handleSampleDoubtSubmit = () => {
    const data = {
      uploadedImageUrl: selectedSampleSolution?.image,
      is_demo: true,
      doubt_uid: selectedSampleSolution?.doubt_uid
    };
    submitDoubt(goalUID, data).then((res) => {
      if (res.success) {
        pushRoute({
          pathname:
            '/goal/[goalSlug]/[goalUID]/doubts-and-solutions/doubt/[doubtUID]',
          query: {
            goalSlug: goalInfo.slug,
            goalUID: goalInfo.uid,
            doubtUID: selectedSampleSolution?.doubt_uid
          }
        });
      }
    });
  };

  const handleNextClick = () => {
    if (isASDEnabled) {
      handleSampleDoubtSubmit();
      setSampleClicked(false);
      return;
    }
    setDrawerScreen(drawerScreens.confirmDetails);
    // eslint-disable-next-line no-use-before-define
    setCurrentFooterState(footerState.confirmDetails);
  };

  const onChangeSampleSolution = (index) => {
    if (doubt_uid !== index) {
      const selectedSolution = samples?.find(
        (sample) => sample?.doubt_uid === index
      );
      setSelectedSampleSolution(selectedSolution);
    }
  };

  const Footer = () => {
    return (
      <FooterWrapper>
        <StyButton
          label={
            currentFooterState === footerState.doubtSelection
              ? 'Next'
              : 'Submit'
          }
          variant="filled"
          color="black"
          width="136px"
          onClick={
            currentFooterState === footerState.doubtSelection
              ? handleNextClick
              : handleSampleDoubtSubmit
          }
        />
      </FooterWrapper>
    );
  };

  useEffect(() => {
    segment.track(DOW2_TRY_AN_EXAMPLE, {
      ...routeGoalSegmentData
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePressBack = () => {
    setCurrentFooterState(footerState.doubtSelection);
    if (drawerScreen === drawerScreens.selectDoubt) setIsDrawerOpened(false);
    else {
      setDrawerScreen(drawerScreens.selectDoubt);
    }
  };

  return (
    <Drawer
      drawerState={isDrawerOpen}
      onClose={() => setIsDrawerOpened(false)}
      showBackButton
      hideCloseButton
      footer={<Footer />}
      onPressBack={handlePressBack}
    >
      <ContentWrapper>
        {drawerScreen === drawerScreens.selectDoubt && (
          <SelectDoubt
            selectedSampleSolution={selectedSampleSolution}
            samples={samples}
            onChangeSampleSolution={onChangeSampleSolution}
          />
        )}
        {drawerScreen === drawerScreens.confirmDetails && (
          <ConfirmSampleDoubtDetails image={image} goalUID={goalUID} />
        )}
      </ContentWrapper>
    </Drawer>
  );
};

export default SampleDoubt;
